import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedicalAppointmentAuditingFilterComponent } from "./medical-appointment-auditing-filter/medical-appointment-auditing-filter.component";
import { MedicalAppointmentAuditingSearchComponent } from "./medical-appointment-auditing-search/medical-appointment-auditing-search.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "src/app/app.material.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { PatientAutocompleteModule } from "../autocomplete/patient/patient-autocomplete.module";
import { ControlsModule } from "../controls/controls.module";
import { SharedModule } from "../shared.module";
import { MedicalAppointmentAuditingControlDialogComponent } from "./medical-appointment-auditing-control-dialog/medical-appointment-auditing-control-dialog.component";
import { MatTableModule } from "@angular/material";
import { MedicalAppointmentAuditingOtherDialogComponent } from "./medical-appointment-auditing-other-dialog/medical-appointment-auditing-other-dialog.component";
import { MedicalAppointmentOrderAuditingComponent } from "./medical-appointment-order-auditing/medical-appointment-order-auditing.component";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { MedicalAppointmentPlanAuditingComponent } from "./medical-appointment-plan-auditing/medical-appointment-plan-auditing.component";
import { TableModule } from "primeng/table";

@NgModule({
  declarations: [
    MedicalAppointmentAuditingFilterComponent,
    MedicalAppointmentAuditingSearchComponent,
    MedicalAppointmentAuditingControlDialogComponent,
    MedicalAppointmentAuditingOtherDialogComponent,
    MedicalAppointmentOrderAuditingComponent,
    MedicalAppointmentPlanAuditingComponent
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PatientAutocompleteModule,
    MatTableModule,
    PipesModule,
    ControlsModule,
    TableModule,
    NgxMaskModule.forRoot(),
  ],
  entryComponents: [
    MedicalAppointmentAuditingControlDialogComponent,
    MedicalAppointmentAuditingOtherDialogComponent,
  ],
})
export class MedicalAppointmentAuditingModule {}
